import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { URL_SERVICIOS } from "../../config/url";
import 'rxjs/add/operator/map';

@Injectable()
export class VehiculoProvider {

  constructor(public http: Http) {
    
  }

  listar_marcas():Promise<any>{
    return new Promise((resolve, reject) => {
      let url = URL_SERVICIOS + "vehiculo/listar_marcas/";
      this.http.get(url)
      .map(resp => resp.json())
      .subscribe(data => {
        if(data.error){
          reject(data);
        }else{
          resolve(data);
        }
      },
      error => {
        console.error(error);
        reject(error);
      });
    });
  }

  listar_lineas(marca):Promise<any>{
    return new Promise((resolve, reject) => {
      let url = URL_SERVICIOS + "vehiculo/listar_lineas/" + marca;
      this.http.get(url)
      .map(resp => resp.json())
      .subscribe(data => {
        if(data.error){
          reject(data);
        }else{
          resolve(data);
        }
      },
      error => {
        console.error(error);
        reject(error);
      });
    });
  }

  buscar(placa):Promise<any>{
    return new Promise((resolve, reject) => {
      let url = URL_SERVICIOS + "vehiculo/buscar/" + placa;
      this.http.get(url)
      .map(resp => resp.json())
      .subscribe(data => {
        if(data.error){
          reject(data);
        }else{
          resolve(data);
        }
      },
      error => {
        console.error(error);
        reject(error);
      });
    });
  }

  buscar1(placa):Promise<any>{
    return new Promise((resolve, reject) => {
      let url = URL_SERVICIOS + "vehiculo/buscar1/" + placa;
      this.http.get(url)
      .map(resp => resp.json())
      .subscribe(data => {
        if(data.error){
          reject(data);
        }else{
          resolve(data);
        }
      },
      error => {
        console.error(error);
        reject(error);
      });
    });
  }

  buscarNombre(marca, linea):Promise<any>{
    return new Promise((resolve, reject) => {
      let url = URL_SERVICIOS + "vehiculo/buscarNombre/" + linea;
      this.http.get(url)
      .map(resp => resp.json())
      .subscribe(data => {
        if(data.error){
          reject(data);
        }else{
          resolve(data);
        }
      },
      error => {
        console.error(error);
        reject(error);
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/vehiculo/vehiculo.ts